(() => {
	const subscriptionPrice = () => ({
		restrict: 'E',
		scope: {
			price: '=',
			isDiscount: '='
		},
		template: `
                 <h2 class="sb-cost-price" ng-class="{'color-froly-dark' : isDiscount}">
                    <span>{{price | profilePrice : "bill"}}</span>
                    <sup>{{price | profilePrice : "coin"}}</sup> 
                 </h2>
            `,
		replace: true,
		transclude: true
	});

	angular.module('main').directive('subscriptionPrice', subscriptionPrice);
})();



// WEBPACK FOOTER //
// ./web/js/components/Subscription/subscriptionPrice.js